import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { withTheme, Theme } from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import { useIntl } from 'react-intl';
import { Collapse } from 'reactstrap';
import { transformLink } from '@whitelabel/helpers/i18n';
import { ReactComponent as IconChevronDown } from '@whitelabel/media/icons/small/chevron-down.svg';
import { ReactComponent as IconChevronUp } from '@whitelabel/media/icons/small/chevron-up.svg';
import { IButtonBlock, IImageBlock } from '@whitelabel/helpers/types';
import {
  StyledItemImageBlock,
  StyledItemHeading,
  StyledItemInner,
  StyledItemButtonBlock,
  StyledAccordionItem,
  StyledItemBody,
  StyledItemHeader,
} from './styled';

type OwnProps = {
  image?: IImageBlock;
  mobileImage?: IImageBlock;
  title: string;
  leadText?: string;
  body?: string;
  /*
    (ts-migrate) TODO: Migrate the remaining prop types
    ...contentBlockPropTypes
    */
  button?: {
    value: IButtonBlock;
  }[];
  theme: Theme;
  anchorId?: string;
};

// @ts-ignore ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof AccordionItem.defaultProps;

// @ts-ignore ts-migrate(7022) FIXME: 'AccordionItem' implicitly has type 'any' because ... Remove this comment to see the full error message
const AccordionItem = ({ body, button, image, mobileImage, title, theme, anchorId }: Props) => {
  const intl = useIntl();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = !useMediaQuery({ minWidth: theme.gridBreakpoints.sm });
  const hasBody = body && body !== '<p></p>';
  const hasButton = button?.length > 0;
  const toggle = () => setIsOpen((prevState) => !prevState);

  useEffect(() => {
    if (history.location.hash === `#${anchorId}`) {
      setIsOpen(true);
    }
  }, [anchorId, history.location.hash]);

  return (
    <StyledAccordionItem id={anchorId} data-test-id="accordion-item">
      <StyledItemHeader onClick={toggle}>
        <StyledItemHeading>
          {title}
          {isOpen ? <IconChevronUp /> : <IconChevronDown />}
        </StyledItemHeading>
      </StyledItemHeader>
      <Collapse isOpen={isOpen}>
        <StyledItemInner>
          <StyledItemImageBlock
            image={mobileImage && isMobile ? mobileImage : image}
            altText={title}
            withMargin={!!title || hasBody}
          />

          {hasBody && (
            <StyledItemBody data-test-id="AccordionItem-body">
              {ReactHtmlParser(body, { transform: transformLink(intl) })}
            </StyledItemBody>
          )}
          {hasButton && <StyledItemButtonBlock {...button[0].value} />}
        </StyledItemInner>
      </Collapse>
    </StyledAccordionItem>
  );
};

AccordionItem.defaultProps = {
  image: null,
  mobileImage: null,
  leadText: null,
  body: null,
  button: null,
  anchorId: null,
};

export default withTheme(AccordionItem);
